<template>
  <!-- CART DROPDOWN -->
  <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <feather-icon icon="ShoppingCartIcon" class="cursor-pointer ml-4 mr-6 mt-1" :badge="cartItems.length" />
      <vs-dropdown-menu class="cart-dropdown vx-navbar-dropdown" :class="{'dropdown-custom': cartItems.length}">

          <!-- IF CART HAVE ITEMS: HEADER -->
          <template v-if="cartItems.length">
              <div class="notification-header text-center p-5 bg-primary text-white">
                  <h3 class="text-white">{{ cartItems.length }} 개<span v-show="cartItems.length > 1"></span></h3>
                  <p class="opacity-75"></p>
              </div>

              <!-- CART ITEMS -->
              <component :is="scrollbarTag" ref="mainSidebarPs" class="scroll-area--cart-items-dropdowm p-0 mb-10" :settings="settings" :key="$vs.rtl">
              <ul class="bordered-items">
                  <li
                    v-for="item in cartItems"
                    :key="item.orderBasketItemSeq"
                    class="vx-row no-gutter cart-item cursor-pointer"
                    @click="$router.push({name: 'ecommerce-item-detail-view', params: {item_id: item.orderBasketItemSeq }}).catch(() => {})">

                      <!-- INFO COL -->
                      <div class="vx-col w-full pr-4 pl-2 py-4 flex flex-col justify-center">
                          <span class="font-medium block cart-item-title truncate">{{ item.productName }}</span>
                          <small class="truncate mb-2">{{ item.brandName }}</small>
                          <div class="flex items-center justify-between">
                              <span class="text-sm font-medium">{{ item.orderCount }} <small>x</small> {{ item.price }} 원</span>
                              <feather-icon icon="XIcon" svgClasses="h-4 w-4 cursor-pointer text-danger" class="hover:text-danger" @click.stop="deleteItemFromCart(item)" />
                          </div>
                      </div>
                  </li>
              </ul>
              </component>
              <div
                class=" checkout-footer fixed bottom-0 rounded-b-lg text-primary font-semibold w-full p-2 text-center border border-b-0 border-l-0 border-r-0 border-solid d-theme-border-grey-light cursor-pointer"
                @click="$router.push('/order/basket-list').catch(() => {})">

                <span class="flex items-center justify-center">
                  <feather-icon icon="ShoppingCartIcon" svgClasses="h-4 w-4" />
                  <span class="ml-2">장바구니로 이동</span>
                </span>

              </div>
          </template>

          <!-- IF CART IS EMPTY -->
          <template v-else>
              <p class="p-4">장바구니가 비었습니다.</p>
          </template>
      </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
import { deleteData } from '@/api/module'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  components: {
    VuePerfectScrollbar
  },
  data () {
    return {
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      userID: this.$store.getters.getUserInfo.userID
    }
  },
  computed: {
    // CART DROPDOWN
    cartItems () {
      return this.$store.state.cartItems.slice().reverse()
    },
    scrollbarTag () {
      return this.$store.getters.scrollbarTag
    }
  },
  methods: {
    async deleteItemFromCart (item) {
      try {
        const orderBasketSeq = item.orderBasketSeq
        const orderBasketItemSeq = item.orderBasketItemSeq
        await deleteData(`order/${orderBasketSeq}/basket/${orderBasketItemSeq}`)
        this.$store.dispatch('loadCartItems', this.userID)

      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    }
  }
}

</script>
